"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.use1DTraceYScale = exports.useScale2DY = exports.useScale2DX = exports.get1DYScale = exports.get1DXScale = exports.get2DYScale = exports.getSliceYScale = exports.get2DXScale = void 0;
const d3_1 = require("d3");
const ml_spectra_processing_1 = require("ml-spectra-processing");
const ChartContext_1 = require("../../context/ChartContext");
const DimensionLayout_1 = require("./DimensionLayout");
function get2DXScale(options, reverse) {
    const { width, margin, xDomain, mode } = options;
    const isReversed = reverse !== undefined ? reverse : mode === 'RTL';
    const range = isReversed
        ? [width - margin.right, margin.left]
        : [margin.left, width - margin.right];
    return (0, d3_1.scaleLinear)(xDomain, range);
}
exports.get2DXScale = get2DXScale;
function useScale2DX(reverse) {
    const { width, margin, xDomain, mode } = (0, ChartContext_1.useChartData)();
    return get2DXScale({ width, margin, xDomain, mode }, reverse);
}
exports.useScale2DX = useScale2DX;
function get2DYScale(options, reverse = false) {
    const { height, margin, yDomain } = options;
    return (0, d3_1.scaleLinear)(yDomain, reverse
        ? [height - margin.bottom, margin.top]
        : [margin.top, height - margin.bottom]);
}
exports.get2DYScale = get2DYScale;
function useScale2DY(reverse) {
    const { height, margin, yDomain } = (0, ChartContext_1.useChartData)();
    return get2DYScale({ height, margin, yDomain }, reverse);
}
exports.useScale2DY = useScale2DY;
function get1DXScale(props, layout) {
    if (!['TOP_1D', 'LEFT_1D'].includes(layout)) {
        throw new Error(`layout is required and must be ${DimensionLayout_1.LAYOUT.TOP_1D} or ${DimensionLayout_1.LAYOUT.LEFT_1D}  `);
    }
    switch (layout) {
        case DimensionLayout_1.LAYOUT.TOP_1D: {
            const { width, margin, xDomain } = props;
            return (0, d3_1.scaleLinear)(xDomain, [width - margin.right, margin.left]);
        }
        case DimensionLayout_1.LAYOUT.LEFT_1D: {
            const { height, margin, yDomain } = props;
            return (0, d3_1.scaleLinear)(yDomain, [height - margin.bottom, margin.top]);
        }
        default:
            break;
    }
}
exports.get1DXScale = get1DXScale;
function get1DYScale(yDomain, height, margin = 10) {
    return (0, d3_1.scaleLinear)(yDomain, [height - margin, margin]);
}
exports.get1DYScale = get1DYScale;
function use1DTraceYScale(SpectrumId, height, verticalMargin) {
    const { yDomains } = (0, ChartContext_1.useChartData)();
    return get1DYScale(yDomains[SpectrumId], height, verticalMargin);
}
exports.use1DTraceYScale = use1DTraceYScale;
function getSliceYScale(data, size, mode, margin = 10) {
    const max = (0, ml_spectra_processing_1.xMaxValue)(data);
    size = mode === 'RTL' ? size : size / 2;
    return (0, d3_1.scaleLinear)([0, max], [size - margin, margin]);
}
exports.getSliceYScale = getSliceYScale;
